export enum TrailRelations {
  system = 'system',
  weatherGroups = 'weatherGroups',
  manualTrailStatuses = 'manualTrailStatuses',
  trailFeatures = 'trailFeatures',
  conditionalStatusGroups = 'conditionalStatusGroups',
  ways = 'ways',
  osmRelations = 'osmRelations',
  trailforksIds = 'trailforksIds',
}
